export const safeParseJson = (
  json: ReturnType<typeof localStorage.getItem>,
): unknown => {
  if (!json) return null;

  try {
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};
